import { generateLoadedUIStateForField } from 'utils/editorDefaultStates';
import { ALL_BRANCHES } from 'utils/conditionalConstants';
import isObject from 'lodash/isObject';

export function trimEmptyLeaves(state, keyPath) {
  if (!state.hasIn(keyPath)) {
    return state;
  }

  const newState = state;
  const popableKeyPath = [...keyPath];
  let mostRecentPop;
  do {
    mostRecentPop = popableKeyPath.pop();
  } while (newState.hasIn(popableKeyPath) && newState.getIn(popableKeyPath).size <= 1);
  return newState.removeIn([...popableKeyPath, mostRecentPop]);
}

export function createUIState(form, fieldOrderCollapsedState, visibleBranches = ALL_BRANCHES) {
  const createUIStateFromNestedObj = (obj) => Object.keys(obj).reduce((acc, curr) => {
    if (isObject(obj[curr])) {
      acc[curr] = createUIStateFromNestedObj(obj[curr]);
    } else {
      acc[curr] = {};
    }
    return acc;
  }, {});

  const newUIState = { visibleBranches };
  newUIState.name = { required: true };

  newUIState.syntheticContentEntities = createUIStateFromNestedObj(form.syntheticContentEntities);

  newUIState.fields = {};

  const fieldIds = Object.keys(form.fields);
  fieldIds.forEach((fieldId) => {
    newUIState.fields[fieldId] = generateLoadedUIStateForField(form.fields[fieldId]);
  });
  newUIState.fieldOrderCollapsedState = fieldOrderCollapsedState;
  return newUIState;
}

export function makeErrorsVisible(state, keyPath) {
  let newState = state;
  if (newState.hasIn([...keyPath, 'error'])) {
    const uiStateKeyPath = keyPath.map((key) => key === 'invalidFormData' ? 'uiState' : key);
    newState = newState.setIn([...keyPath, 'error', 'visible'], true)
      .setIn([...uiStateKeyPath, 'touched'], true);
  }

  const stateKeys = newState.getIn(keyPath).keySeq().toArray();
  stateKeys.forEach((key) => {
    if (key !== 'error') {
      newState = makeErrorsVisible(newState, [...keyPath, key]);
    }
  });

  return newState;
}

export const makeDirty = (state) => state.setIn(['meta', 'isDirty'], true);
